/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeamPickerWithActions_userTeams = {
    readonly list: ReadonlyArray<{
        readonly teamId: string;
        readonly teamName: string;
    }>;
    readonly " $refType": "TeamPickerWithActions_userTeams";
};
export type TeamPickerWithActions_userTeams$data = TeamPickerWithActions_userTeams;
export type TeamPickerWithActions_userTeams$key = {
    readonly " $data"?: TeamPickerWithActions_userTeams$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeamPickerWithActions_userTeams">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamPickerWithActions_userTeams",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "list",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "teamId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "teamName",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "TeamList",
    "abstractKey": null
} as any;
(node as any).hash = '7e3e035452b553654468ba5342a98514';
export default node;
